import React, { useState, useEffect } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Dropdown from "react-bootstrap/Dropdown";
import Alert from "react-bootstrap/Alert";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
// import Footer from "../../../../footer.js";   // ← agar use nahi kar rahe to comment out
import Details from "./details.js";
import Preference from "./preference";
import Contacts from "./contacts";
import Notes from "./notes.js";
import Instruction from "./instruction.js";
import PriceList from "./pricelist.js";
import Procedures from "./procedure.js";
import Activity from "./activity.js";
import Header from "../../../../header/header.js";
import Navvbar from "../../../../header/Navvbar.js";
import Sidebar from "../../../../Sidebar.js";
import "./tabsworking.css";
function TabsWorking() {
  const location = useLocation();
  const { accountId } = useParams();
  const navigate = useNavigate();

  const [accountData, setAccountData] = useState(
    location.state?.accountData || {}
  );

  const [accountName, setAccountName] = useState(
    location.state?.accountName || "Account Details"
  );

  const [activeTab, setActiveTab] = useState("Details");
  const [inviteMessage, setInviteMessage] = useState(false);

  const enabledTabs = ["Details", "Contacts"];

  useEffect(() => {
    if (!location.state?.accountData && accountId) {
      const fetchAccountData = async () => {
        try {
          const response = await fetch(
            `https://hms.backend.hiragroupcloud.com/api/account/account/${accountId}`
          );
          const data = await response.json();

          if (response.ok) {
            setAccountData(data);
            setAccountName(
              data.account_name || data.name || "Account Details"
            );
          } else {
            throw new Error(data.message || "Failed to fetch account data");
          }
        } catch (error) {
          console.error("Error fetching account data:", error);
          navigate("/accounts");
        }
      };
      fetchAccountData();
    }
  }, [accountId, location.state?.accountData, navigate]);

  const handleNavigation = (path, state) => {
    navigate(path, { state });
  };

  const handleInviteClick = () => {
    setInviteMessage(true);
  };

  const handleTabSelect = (k) => {
    if (enabledTabs.includes(k)) {
      setActiveTab(k);
    }
  };

  return (
    <>
      <Header />
      <Navvbar />
      <br />

      {/* ✅ SAME CONTAINER AS EDIT USER / LAB DETAILS PAGE */}
      <div style={{ width: "95%", margin: "0 auto", padding: "0" }}>
        <div className="row">

          {/* ✅ SIDEBAR — same class as Users/EditUser page */}
          <div className="col-md-2 users-sidebar-col">
            <Sidebar />
          </div>

          {/* ✅ MAIN CONTENT — same class as Users/EditUser page */}
          <div className="col-md-10 users-main-content-col">

            <div
              className="d-flex justify-content-between align-items-center"
              style={{ width: "100%" }}
            >
              <h1 className="users-main-heading">
                Account {accountName}
              </h1>

              <Dropdown>
                <Dropdown.Toggle
                  variant="primary"
                  id="dropdown-custom-components"
                  className="tabs-working-action-button"
                  style={{
                    backgroundColor: "#004aad",
                    borderColor: "#004aad",
                    color: "white",
                    borderRadius: "5px",
                    boxShadow: "none",
                  }}
                >
                  Action
                </Dropdown.Toggle>

                <Dropdown.Menu style={{ minWidth: "200px", fontSize: "15px" }}>
                  <Dropdown.Header style={{ fontSize: "18px", fontWeight: "bold" }}>
                    Cases
                  </Dropdown.Header>

                  <Dropdown.Item
                    as={Link}
                    to="/openCases"
                    state={{ accountName, accountId }}
                    onClick={() =>
                      handleNavigation("/openCases", { accountName, accountId })
                    }
                  >
                    View Open Cases
                  </Dropdown.Item>

                  <Dropdown.Item
                    as={Link}
                    to="/casesOpened"
                    state={{ accountName, accountId }}
                    onClick={() =>
                      handleNavigation("/casesOpened", { accountName, accountId })
                    }
                  >
                    View All Cases
                  </Dropdown.Item>

                  <Dropdown.Item as={Link} to="/View cases To Ship">
                    View Cases To Ship
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/Create Cases">
                    Create Cases
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/New Cases Pickup">
                    New Cases Pickup
                  </Dropdown.Item>

                  <Dropdown.Divider />

                  <Dropdown.Header style={{ fontSize: "18px", fontWeight: "bold" }}>
                    Patients
                  </Dropdown.Header>
                  <Dropdown.Item as={Link} to="/View All Patients">
                    View All Patients
                  </Dropdown.Item>

                  <Dropdown.Divider />

                  <Dropdown.Header style={{ fontSize: "18px", fontWeight: "bold" }}>
                    Invite
                  </Dropdown.Header>
                  <Dropdown.Item onClick={handleInviteClick}>
                    Invite to DDX
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>

            {inviteMessage && (
              <Alert
                variant="success"
                style={{ marginTop: "10px", width: "fit-content" }}
              >
                ✅ Invite has been sent. Your account is now connected with DDX.
              </Alert>
            )}

            <div className="tabs-working-tabs">
              <Tabs
                activeKey={activeTab}
                onSelect={handleTabSelect}
                id="uncontrolled-tab-example"
                className="mb-3 custom-nav-bar"
              >
                {[
                  { key: "Details", title: "Details", component: <Details accountData={accountData} /> },
                  { key: "Preferences", title: "Preferences", component: <Preference accountData={accountData} /> },
                  { key: "Contacts", title: "Contacts", component: <Contacts accountData={accountData} /> },
                  { key: "Notes", title: "Notes", component: <Notes accountData={accountData} /> },
                  { key: "Instruction", title: "Instructions", component: <Instruction accountData={accountData} /> },
                  { key: "pricelist", title: "Price List", component: <PriceList accountData={accountData} /> },
                  { key: "Procedures", title: "Procedures", component: <Procedures accountData={accountData} /> },
                  { key: "Activity", title: "Activity", component: <Activity accountData={accountData} /> },
                ].map((tab) => {
                  const isEnabled = enabledTabs.includes(tab.key);
                  return (
                    <Tab
                      key={tab.key}
                      eventKey={tab.key}
                      title={tab.title}
                      disabled={!isEnabled}
                    >
                      {tab.component}
                    </Tab>
                  );
                })}
              </Tabs>
            </div>
          </div>
        </div>

        <div
          className="tabs-working-footer"
          style={{ width: "100%", display: "block", visibility: "visible" }}
        ></div>
      </div>
    </>
  );
}

export default TabsWorking;